export const tableColumnList = [
  {
    field: 'productName', // 1
    title: '中转物资名称',
    width: '150',
    editRender: {
      name: 'productName',
    },
  },
  {
    field: 'arrivedVolume',
    title: '本月到货量(万吨)',
    width: '150',
    editRender: { name: 'arrivedVolume' },
  },

  {
    field: 'shipmentVolume',
    title: '本月出货量(万吨)',
    width: '150',
    editRender: {
      name: 'shipmentVolume',
    },
  },

  {
    field: 'throughputMonth',
    title: '本月吞吐量(万吨)',
    width: '150',
    editRender: {
      name: 'throughputMonth',
    },
  },
  {
    field: 'arrivalSumYear',
    title: '本年累计到货量(万吨)',
    width: '150',
    editRender: {
      name: 'arrivalSumYear',
    },
  },
  {
    field: 'shipmentSumYear',
    title: '本年累计出货量(万吨)',
    width: '150',
    editRender: {
      name: 'shipmentSumYear',
    },
  },
  {
    field: 'throughputSumYear',
    title: '本年累计吞吐量(万吨)',
    width: '150',
    editRender: {
      name: 'throughputSumYear',
    },
  },
  {
    field: 'inventoryEnd',
    title: '期末存货(万吨)',
    width: '150',
    editRender: {
      name: 'inventoryEnd',
    },
  },
  {
    field: 'inventoryYearInit',
    title: '年初存货(万吨)',
    width: '150',
    editRender: {
      name: 'inventoryYearInit',
    },
  },
  {
    field: 'remark',
    title: '备注',
    width: '200',
    editRender: {
      name: 'remark',
    },
  },
];

export const tableRules = {
  // productName: [{ required: true, message: '中转物资名称不能为空' }],
  // arrivedVolume: [{ required: true, message: '到货量不能为空' }],
  // shipmentVolume: [{ required: true, message: '出货量不能为空' }],
  // inventoryYearInit: [{ required: true, message: '年初存货不能为空' }],
};
